import { useState } from "react";
import { observer } from "mobx-react-lite";
import { BaseModalDialog } from "../../../../components/modals/base-modal-dialog";
import { CityPicker } from "./city-picker";
import { LocationPicker } from "./location-picker";
import { LocationPickerContextProvider, ModalType } from "./context";
import { useStores } from "../../../../stores";
import { MapPicker } from "./map-picker";

interface ResellerLocationModalProps {
  isOpen: boolean;
  handleSubmitLocation: () => void;
  onClose: () => void;
}

export const ResellerLocationModal: React.FC<ResellerLocationModalProps> =
  observer(({ isOpen, onClose, handleSubmitLocation }) => {
    const { coverageAreaStore } = useStores();
    const [modalType, setModalType] = useState<ModalType>(null);

    const onSubmit = () => {
      handleSubmitLocation();
      setModalType(null);
      onClose();
    };

    const renderScene = () => {
      switch (modalType) {
        case ModalType.cityPicker:
          return <CityPicker />;
        case ModalType.mapPicker:
          return <MapPicker />;
        default:
          return <LocationPicker />;
      }
    };

    return (
      <LocationPickerContextProvider
        value={{
          modalType,
          setModalType,
          onSubmit: onSubmit,
          onClose,
        }}
      >
        <BaseModalDialog
          isOpen={isOpen}
          onClose={onClose}
          shouldCloseOnOverlayClick={!!coverageAreaStore?.selectedCoverageArea}
          className="w-full overflow-y-visible"
        >
          {renderScene()}
        </BaseModalDialog>
      </LocationPickerContextProvider>
    );
  });
